import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";

// Layout Components
import Sidebar from "./components/sidebar";
import TopNav from "./components/topnav";

// Auth Pages
import SignIn from "./signInPage.jsx";
import Register from "./components/register";

// User Role-specific Components
import Dashboard from "./components/dashboard";
import LawyerProfiles from "./components/lawyerprofiles";
import LawyerDetails from "./components/lawyerComponents/lawyerDetailPage";
import ListOfLawyers from "./components/lawyerComponents/ListOfLawyers";
import ClientSideBar from "./components/clientSidebar";
import StudentSideBar from "./components/studentSideBar";
import OfficialSideBar from "./components/sidebarOfficial";
import OfficialTable from "./components/officialComponents/officialTable";
import AddEventForm from "./components/officialComponents/officialAddEvent";

// Settings and Misc
import SettingsSideBar from "./components/settingsSidebar";
import BannerPage from "./components/bannerPage/bannerPage";
import AboutUs from "./components/settingsComponents/aboutUsComponent";
import Upload from "./components/upload";
import { useAuth,AuthProvider } from "./authcontext.jsx";
import CaseInfoPage from "./components/clientComponents/caseInfoPage.jsx";
// Protected Route wrapper component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
}

const SignInWrapper = () => {
  const { login } = useAuth();
  return <SignIn onSignIn={login} />;
};

// Layout wrapper for authenticated pages
const AuthenticatedLayout = ({ children }) => (
  <>
    <Sidebar />
    <div className="main-content">
      <TopNav />
      {children}
    </div>
  </>
);
const App = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<SignInWrapper />} />
            <Route path="/register" element={<Register />} />

            {/* Protected routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <Dashboard />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            {/* User management routes */}
            <Route path="/lawyers/*" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <Routes>
                    <Route path="/" element={<LawyerProfiles />} />
                    <Route path="/details" element={<LawyerDetails />} />
                    <Route path="/list" element={<ListOfLawyers />} />
                  </Routes>
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            <Route path="/students" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <StudentSideBar />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            <Route path="/clients" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <ClientSideBar />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            {/* Official routes */}
            <Route path="/sidebarOffc" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <Routes>
                    <Route path="/" element={<OfficialSideBar />} />
                    <Route path="/table" element={<OfficialTable />} />
                    <Route path="/add-event" element={<AddEventForm />} />
                  </Routes>
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            {/* Settings and utilities */}
            <Route path="/settings" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <SettingsSideBar />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            <Route path="/banner" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <BannerPage />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            <Route path="/about" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <AboutUs />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            <Route path="/addevent" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <AddEventForm />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            <Route path="/upload" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <Upload />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

            <Route path="/lawyer-details" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <LawyerDetails />
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />

          <Route path="/case-info" element={
              <ProtectedRoute>
                <AuthenticatedLayout>
                  <CaseInfoPage/>
                </AuthenticatedLayout>
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;